import React, { useCallback, useEffect, useState } from 'react';
import { getTemplate, submitForm } from '../api';

interface WidgetProps {
    recaptcha: any;
    formId: string;
    host: string;
}

const unlayerHtml = (form: string) => ({ __html: form || '' });

const Widget: React.FC<WidgetProps> = ({ recaptcha, formId, host }) => {
    const [form, setForm] = useState('');

    const [showMessage, setShowMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState<string | undefined>(undefined);
    const [hasError, setError] = useState(false);

    const getTemplateForm = useCallback(async () => {
        const template = await getTemplate(host, formId);
        setForm(template);
    }, [formId, host]);

    useEffect(() => {
        getTemplateForm();
    }, [getTemplateForm]);

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        setShowMessage(false);
        setError(false);
        await recaptcha.current.executeAsync();
        const recaptchaResponse = recaptcha.current.props.grecaptcha.getResponse();
        const renderedForm = document.querySelector('form');
        const formData = new FormData(renderedForm || undefined);

        const result = await submitForm(host, formId, {
            recaptchaResponse,
            email: formData.get('email') || '',
            firstName: formData.get('firstname') || '',
            lastName: formData.get('lastname') || '',
            subscriptions: formData.getAll('subscription'),
            ageCheck: !!formData.get('agecheck'),
        });

        if (result.link && result.success) {
            window.open(result.link, '_blank');
        }

        setShowMessage(true);
        setSuccessMessage(result.successMessage);
        setError(!result.success);
    };

    return (
        <>
            {
                !showMessage || (showMessage && hasError) ? (
                    <div
                        className="form-container"
                        dangerouslySetInnerHTML={unlayerHtml(form)}
                        onSubmit={handleSubmit}
                    />
                ) : (
                    <div className="container">
                        {
                            successMessage ? (
                                <div className="title">{successMessage}</div>
                            ) : (
                                <div className="message">
                                    <div className="title">Thank you for subscribing</div>
                                    <div className="content">We have added you to the mailing lists you selected.</div>
                                </div>
                            )
                        }
                    </div>
                )
            }

            {
                showMessage && hasError && (
                    <div className="container">
                        <div className="error">
                            There was an error trying to submit the form. Please try again later
                        </div>
                    </div>
                )
            }

        </>
    );
};

export default Widget;
